import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";

export default (props) => {
/*
    console.log(`ItemInject: props.viewMethod=${JSON.stringify(props.viewMethod)} rowKey=${JSON.stringify(props.rowKey)}`);
    console.log(`props=${JSON.stringify(props)}`);
*/
    return <ItemInjector key={props.row.MethodName}
        dataItem={{
        controller: "SelfService",
        methodName: props.row.MethodName,
        withParamset : true,
        fieldName: props.row.SelfServiceFrameId
    }}><ConnectedSelfServiceFrame {...props} /></ItemInjector>
};

class SelfServiceFrame extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false,
            uploadVisible: false,
            updateStateFlag: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.row.MethodName !== this.props.row.MethodName) {
            this.initialize();
        }
    }

    initialize = async () => {
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.dataItem.reset());
                await this.props.dispatch(this.props.dataItem.initialize({}, {
                    withParams: false,
                    withStyle: false
                }));
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }
    paramRender = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    const editor = fn === "PageHelp" ? renderHTML(fi.Value): h.ed(fn);
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {editor}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    render() {
        let control = this.props.dataItem.rowsCount() === 0
            ? <div className="text-muted mb-2">{i18next.t("Data_Not_Found_1")}</div>
            : <ComplexParam dataItem={this.props.dataItem} showApplyButton={false}
                            showSearchBar={false}
                            onEndEditField={async (rowIndex, fieldDescriptor) => {
                                await this.props.dispatch(this.props.dataItem.save(rowIndex));
                            }}
                            renderParams={this.paramRender}/>;
        const frameStatusText = this.props.dataItem.getField(0, 'PageStatusText');
        const addHeaderInfo = <div className="col-md-6"><span
            className={`badge badge-pill text-wrap ${frameStatusText ? 'badge-primary' : 'badge-danger'}`}>{frameStatusText ? frameStatusText : i18next.t('Заполните данные')}</span>
        </div>;
        return (
            <PlaceholderWrapper placeholderId={this.props.row.SelfServiceFrameId} showSplitterLine={false}
                                key={this.props.row.SelfServiceFrameId}
                                canCollapse={true} collapsed={true}
                                classNameOpen="placeholderWrapper-collapseButton-left placeholder-open"
                                classNameClose="placeholderWrapper-collapseButton-left placeholder-close"
                                iconPlacement="before"
                                title={this.props.row.SelfServiceFrameName}
                                staticTitle={this.props.row.SelfServiceFrameName}
                                addHeaderTitle={addHeaderInfo}
            >
                <div className="ml-2">
                    {
                        this.state.isDataReady
                            ? control
                            : i18next.t('LoadingLabel')
                    }
                </div>
            </PlaceholderWrapper>
        );
    }

    uploadDocument = (row) => {
        this.setState({uploadVisible: true});
    }
    onCloseUploadDocument = () => {
        this.setState({uploadVisible: false, updateStateFlag: Date.now()});
    }
}

SelfServiceFrame.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    row: PropTypes.object
}

SelfServiceFrame.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.getItemState(state)
    }
}

const ConnectedSelfServiceFrame = connect(mapStateToProps)(SelfServiceFrame);